import { adminHttpClient } from '../../../../commons/adminHttpClient'
import { FamilyMemberRelationship } from 'domain/companies/familyMemberRelationship'

export interface AddFamilyMember {
  firstName: string
  lastName: string
  familyMemberRelationship: FamilyMemberRelationship
}

const addFamilyMember = (values: AddFamilyMember): Promise<any> => {
  return adminHttpClient.post('/EEDashboard/GetReimbursed/FamilyMember/AddFamilyMember', values)
}

export default addFamilyMember
